module.exports = __webpack_public_path__ + "static/media/fly0138.54e6eab6.webp";